import { SelectProps, Select as SelectAntD } from 'antd';
import { FC } from 'react';

export const Select: FC<SelectProps> = (props) => {
	return <SelectAntD {...props} />;
};
